import {
    AttendingPhysicianStatusIds,
    GetIdsHealthcareservicesHcsIdPatientsParams,
    PatientListWithInsiIdentityStatusDtoIds,
} from '@toktokdoctech/tokapi-client'
import { TokTokDocDataTableHeader, TokTokDocDataTableCell } from '../../Common/_props/TokTokDocDataTableProps'

const getAttendingPhysicianStatusLabel = (status: AttendingPhysicianStatusIds): string => {
    switch (status) {
        case AttendingPhysicianStatusIds.Yes:
            return 'Oui'
        case AttendingPhysicianStatusIds.No:
            return 'Aucun'
        case AttendingPhysicianStatusIds.NotSpecified:
            return 'Non renseigné'
        default: {
            throw new Error(`[Patients Filters] - unmanaged attendingPhysicianStatus: ${status}`)
        }
    }
}

export const attendingPhysicianStatusOptions = Object.values(AttendingPhysicianStatusIds).map((status) => ({
    value: status,
    label: getAttendingPhysicianStatusLabel(status),
}))

export type PatientListProps = {
    isWorkbench?: boolean
}

export type PatientListFiltersProps = {
    onChange: (filters: PatientFilters) => void
    onMessage: (message: Message | null) => void
    filters: PatientFilters
    isWorkbench: boolean
}

export type PatientsDataTableRow = PatientListWithInsiIdentityStatusDtoIds & {
    objectId: string
}

export type PatientFilters = Partial<Omit<GetIdsHealthcareservicesHcsIdPatientsParams, 'skip' | 'limit'>>

export type PatientsDataTableProps = {
    filters: PatientFilters
    onMessage: (message: Message | null) => void
}

export type Message = {
    text: string
    level: 'info' | 'error'
}

export type UsePatientDataTableConfigProps = {
    handleSort: () => void
    sort: string
    isAdvancedModeActivated: boolean
}

export type PatientDataTableHeaderName =
    | 'INS'
    | 'birthName'
    | 'firstFirstName'
    | 'firstNames'
    | 'birthDate'
    | 'sex'
    | 'requiredExpertInCharge'
    | 'actions'

export type PatientDataTableHeadersMap = Record<PatientDataTableHeaderName, TokTokDocDataTableHeader>
export type PatientDataTableCellsMap = Record<PatientDataTableHeaderName, TokTokDocDataTableCell>
